import { useEffect, useRef, useState } from "react";

const ChevronLeft = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M15 18l-6-6 6-6" /></svg>;
const ChevronRight = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 18l6-6-6-6" /></svg>;
const ChevronsLeft = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 17l-5-5 5-5" /><path d="M18 17l-5-5 5-5" /></svg>;
const ChevronsRight = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M13 17l5-5-5-5" /><path d="M6 17l5-5-5-5" /></svg>;
const ChevronDown = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M6 9l6 6 6-6" /></svg>;
const CalendarIcon = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" /><path d="M16 2v4M8 2v4M3 10h18" /></svg>;
const ListIcon = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><line x1="8" y1="6" x2="21" y2="6" /><line x1="8" y1="12" x2="21" y2="12" /><line x1="8" y1="18" x2="21" y2="18" /><line x1="3" y1="6" x2="3.01" y2="6" /><line x1="3" y1="12" x2="3.01" y2="12" /><line x1="3" y1="18" x2="3.01" y2="18" /></svg>;
const ZapIcon = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" /></svg>;
const SearchIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="11" cy="11" r="8" /><path d="m21 21-4.35-4.35" />
    </svg>
);
const XIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M18 6L6 18M6 6l12 12" />
    </svg>
);

export const Select = ({ label, options = [], value, onChange, placeholder, disabled = false, icon = "", iconClick = "" }) => {
    const [open, setOpen] = useState(false);
    const [search, setSearch] = useState("");
    const containerRef = useRef(null);
    const searchRef = useRef(null);

    const selectedOption = options.find(opt => opt.value === value);

    // Cerrar al click fuera
    useEffect(() => {
        const handler = (e) => {
            if (containerRef.current && !containerRef.current.contains(e.target)) {
                setOpen(false);
                setSearch("");
            }
        };
        document.addEventListener("mousedown", handler);
        return () => document.removeEventListener("mousedown", handler);
    }, []);

    // Enfocar buscador al abrir
    useEffect(() => {
        if (open && searchRef.current) {
            setTimeout(() => searchRef.current?.focus(), 50);
        }
    }, [open]);

    const filtered = options.filter(opt =>
        opt.label.toLowerCase().includes(search.toLowerCase())
        // opt.value.toLowerCase().includes(search.toLowerCase())
    );

    const handleSelect = (val) => {
        onChange(val);
        setOpen(false);
        setSearch("");
    };

    return (
        <div
            className={`pa-select ${open ? "open" : ""} ${disabled ? "disabled" : ""}`}
            ref={containerRef}
        >

            <div className="pa-select__label-wrap">
                <label className="pa-select__label">{label}</label>
                {icon && (
                    <span
                        className="pa-select__label-icon"
                        onClick={typeof iconClick === 'function' ? iconClick : undefined}
                    >
                        {icon}
                    </span>
                )}
            </div>


            <button
                className="pa-select__trigger"
                onClick={() => !disabled && setOpen(o => !o)}
                type="button"
                disabled={disabled}
            >
                <span className={value ? "" : "placeholder"}>
                    {selectedOption ? selectedOption.label : placeholder}
                </span>
                <ChevronDown />
            </button>

            {open && !disabled && (
                <div className="pa-select__dropdown">

                    {/* ── Buscador ── */}
                    <div className="msc-search">
                        <SearchIcon />
                        <input
                            ref={searchRef}
                            type="text"
                            className="msc-search__input"
                            placeholder="Buscar..."
                            value={search}
                            onChange={e => setSearch(e.target.value)}
                            onClick={e => e.stopPropagation()}
                        />
                        {search && (
                            <button
                                type="button"
                                className="msc-search__clear"
                                onClick={() => setSearch("")}
                                tabIndex={-1}
                            >
                                <XIcon />
                            </button>
                        )}
                    </div>

                    {/* ── Opciones filtradas ── */}
                    <div className="msc-list">
                        {filtered.length === 0 ? (
                            <div className="msc-empty">
                                Sin resultados para "<b>{search}</b>"
                            </div>
                        ) : (
                            filtered.map(opt => (
                                <div
                                    key={opt.value}
                                    className={`pa-select__option ${opt.value === value ? "selected" : ""}`}
                                    onClick={() => handleSelect(opt.value)}
                                >
                                    {opt.label}
                                </div>
                            ))
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};
